// import React, { useState } from 'react';
// import './AddCertificateForm.css';

// const emptyForm = {
//   studentName: '',
//   branch: '',
//   course: '',
//   centre: 'Dhanbad',
//   startDate: '',
//   endDate: '',
//   awardedOn: '',
//   certNo: '',
// };

// /**
//  * Step 1: admin fills in the student's details.
//  * On submit, calls onSaved(savedCertificateRecord) so the parent can
//  * move on to the "Generate Certificate" preview screen.
//  */
// const AddCertificateForm = ({ onSaved }) => {
//   const [form, setForm] = useState(emptyForm);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (!form.studentName || !form.branch || !form.course || !form.startDate || !form.endDate) {
//       setError('Please fill in all required fields.');
//       return;
//     }

//     setSaving(true);
//     try {
//       // Replace this URL with your real backend endpoint.
//       const res = await fetch('/api/certificates', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(form),
//       });

//       if (!res.ok) throw new Error('Failed to save student details');

//       const saved = await res.json(); // expected to include a generated certId
//       onSaved(saved);
//       setForm(emptyForm);
//     } catch (err) {
//       setError(err.message || 'Something went wrong while saving.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="acf-card">
//       <div className="acf-body">
//         <h4 className="acf-heading">Add Student Details</h4>

//         {error && <div className="acf-alert-error">{error}</div>}

//         <form className="acf-form" onSubmit={handleSubmit}>
//           <div className="acf-row">
//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Student Name *</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="studentName"
//                 value={form.studentName}
//                 onChange={handleChange}
//                 placeholder="e.g. Subash Kumar"
//               />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Branch *</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="branch"
//                 value={form.branch}
//                 onChange={handleChange}
//                 placeholder="e.g. Civil Engineering"
//               />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Course / Training *</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="course"
//                 value={form.course}
//                 onChange={handleChange}
//                 placeholder="e.g. AutoCAD & Sketchup Pro"
//               />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Training Centre</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="centre"
//                 value={form.centre}
//                 onChange={handleChange}
//                 placeholder="e.g. Dhanbad"
//               />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Start Date *</label>
//               <input
//                 type="date"
//                 className="acf-input"
//                 name="startDate"
//                 value={form.startDate}
//                 onChange={handleChange}
//               />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">End Date *</label>
//               <input
//                 type="date"
//                 className="acf-input"
//                 name="endDate"
//                 value={form.endDate}
//                 onChange={handleChange}
//               />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Awarded On</label>
//               <input
//                 type="date"
//                 className="acf-input"
//                 name="awardedOn"
//                 value={form.awardedOn}
//                 onChange={handleChange}
//               />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Certificate No.</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="certNo"
//                 value={form.certNo}
//                 onChange={handleChange}
//                 placeholder="Leave blank to auto-generate"
//               />
//             </div>
//           </div>

//           <button type="submit" className="acf-submit-btn" disabled={saving}>
//             {saving ? 'Saving...' : 'Save Student Details'}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddCertificateForm;















// /////////////

// import React, { useState } from 'react';
// import './AddCertificateForm.css';

// /**
//  * Generates a certificate number on the frontend only.
//  * Format: DTECH-<YEAR>-<6 random alphanumeric chars>
//  * e.g. DTECH-2026-A1B2C3
//  * No backend involvement — purely client-side so nothing on the server changes.
//  */
// const generateCertNo = () => {
//   const year = new Date().getFullYear();
//   const randomPart = Math.random().toString(36).substring(2, 8).toUpperCase();
//   const num=Math.floor(Math.random() * 100).toString().padStart(2, '0');
//   return `DTECH${num}${randomPart}`;
// };

// const getEmptyForm = () => ({
//   studentName: '',
//   branch: '',
//   course: '',
//   centre: 'Dhanbad',
//   startDate: '',
//   endDate: '',
//   awardedOn: '',
//   certNo: generateCertNo(),
// });

// /**
//  * Step 1: admin fills in the student's details.
//  * On submit, calls onSaved(savedCertificateRecord) so the parent can
//  * move on to the "Generate Certificate" preview screen.
//  */
// const AddCertificateForm = ({ onSaved }) => {
//   const [form, setForm] = useState(getEmptyForm);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (!form.studentName || !form.branch || !form.course || !form.startDate || !form.endDate) {
//       setError('Please fill in all required fields.');
//       return;
//     }

//     setSaving(true);
//     try {
//       // Replace this URL with your real backend endpoint.
//       const res = await fetch('/api/certificates', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(form),
//       });

//       if (!res.ok) throw new Error('Failed to save student details');

//       const saved = await res.json(); // expected to include a generated certId
//       onSaved(saved);
//       setForm(getEmptyForm());
//     } catch (err) {
//       setError(err.message || 'Something went wrong while saving.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="acf-card">
//       <div className="acf-body">
//         <h4 className="acf-heading">Add Student Details</h4>

//         {error && <div className="acf-alert-error">{error}</div>}

//         <form className="acf-form" onSubmit={handleSubmit}>
//           <div className="acf-row">
//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Student Name *</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="studentName"
//                 value={form.studentName}
//                 onChange={handleChange}
//                 placeholder="e.g. Subash Kumar"
//               />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Branch *</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="branch"
//                 value={form.branch}
//                 onChange={handleChange}
//                 placeholder="e.g. Civil Engineering"
//               />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Course / Training *</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="course"
//                 value={form.course}
//                 onChange={handleChange}
//                 placeholder="e.g. AutoCAD & Sketchup Pro"
//               />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Training Centre</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="centre"
//                 value={form.centre}
//                 onChange={handleChange}
//                 placeholder="e.g. Dhanbad"
//               />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Start Date *</label>
//               <input
//                 type="date"
//                 className="acf-input"
//                 name="startDate"
//                 value={form.startDate}
//                 onChange={handleChange}
//               />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">End Date *</label>
//               <input
//                 type="date"
//                 className="acf-input"
//                 name="endDate"
//                 value={form.endDate}
//                 onChange={handleChange}
//               />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Awarded On</label>
//               <input
//                 type="date"
//                 className="acf-input"
//                 name="awardedOn"
//                 value={form.awardedOn}
//                 onChange={handleChange}
//               />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Certificate No.</label>
//               <input
//                 type="text"
//                 className="acf-input"
//                 name="certNo"
//                 value={form.certNo}
//                 onChange={handleChange}
//                 placeholder="Leave blank to auto-generate"
//                 readOnly
//                 disabled
//                 className="acf-input-disabled"
//               />
//             </div>
//           </div>

//           <button type="submit" className="acf-submit-btn" disabled={saving}>
//             {saving ? 'Saving...' : 'Save Student Details'}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddCertificateForm;








////


// import React, { useState } from 'react';
// import './AddCertificateForm.css';

// const generateCertNo = () => {
//   const year = new Date().getFullYear();
//   const randomPart = Math.random().toString(36).substring(2, 8).toUpperCase();
//   const num = Math.floor(Math.random() * 100).toString().padStart(2, '0');
//   return `DTECH${num}${randomPart}`;
// };

// const getEmptyForm = () => ({
//   studentName: '',
//   branch: '',
//   course: '',
//   centre: 'Dhanbad',
//   startDate: '',
//   endDate: '',
//   awardedOn: '',
//   certNo: generateCertNo(),
// });

// /**
//  * Handles both create and edit.
//  * Pass `initialData` (an existing certificate record) to switch into edit mode.
//  * Pass `onCancel` to show a "Cancel" button (useful when editing).
//  */
// const AddCertificateForm = ({ onSaved, initialData = null, onCancel }) => {
//   const isEditMode = Boolean(initialData);

//   const [form, setForm] = useState(() =>
//     isEditMode
//       ? {
//           studentName: initialData.studentName || '',
//           branch: initialData.branch || '',
//           course: initialData.course || '',
//           centre: initialData.centre || 'Dhanbad',
//           startDate: initialData.startDate || '',
//           endDate: initialData.endDate || '',
//           awardedOn: initialData.awardedOn || '',
//           certNo: initialData.certNo || generateCertNo(),
//         }
//       : getEmptyForm()
//   );
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (!form.studentName || !form.branch || !form.course || !form.startDate || !form.endDate) {
//       setError('Please fill in all required fields.');
//       return;
//     }

//     setSaving(true);
//     try {
//       const url = isEditMode
//         ? `/api/certificates/${initialData.certId}`
//         : '/api/certificates';
//       const method = isEditMode ? 'PUT' : 'POST';

//       const res = await fetch(url, {
//         method,
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(form),
//       });

//       if (!res.ok) throw new Error(isEditMode ? 'Failed to update student details' : 'Failed to save student details');

//       const saved = await res.json();
//       onSaved(saved);
//       if (!isEditMode) setForm(getEmptyForm());
//     } catch (err) {
//       setError(err.message || 'Something went wrong while saving.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="acf-card">
//       <div className="acf-body">
//         <h4 className="acf-heading">{isEditMode ? 'Edit Student Details' : 'Add Student Details'}</h4>

//         {error && <div className="acf-alert-error">{error}</div>}

//         <form className="acf-form" onSubmit={handleSubmit}>
//           <div className="acf-row">
//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Student Name *</label>
//               <input type="text" className="acf-input" name="studentName" value={form.studentName} onChange={handleChange} placeholder="e.g. Subash Kumar" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Branch *</label>
//               <input type="text" className="acf-input" name="branch" value={form.branch} onChange={handleChange} placeholder="e.g. Civil Engineering" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Course / Training *</label>
//               <input type="text" className="acf-input" name="course" value={form.course} onChange={handleChange} placeholder="e.g. AutoCAD & Sketchup Pro" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Training Centre</label>
//               <input type="text" className="acf-input" name="centre" value={form.centre} onChange={handleChange} placeholder="e.g. Dhanbad" />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Start Date *</label>
//               <input type="date" className="acf-input" name="startDate" value={form.startDate} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">End Date *</label>
//               <input type="date" className="acf-input" name="endDate" value={form.endDate} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Awarded On</label>
//               <input type="date" className="acf-input" name="awardedOn" value={form.awardedOn} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Certificate No.</label>
//               <input type="text" className="acf-input acf-input-disabled" name="certNo" value={form.certNo} readOnly disabled />
//             </div>
//           </div>

//           <div className="acf-btn-row" style={{ display: 'flex', gap: '10px' }}>
//             <button type="submit" className="acf-submit-btn" disabled={saving}>
//               {saving ? 'Saving...' : isEditMode ? 'Update Student Details' : 'Save Student Details'}
//             </button>
//             {isEditMode && onCancel && (
//               <button type="button" className="acf-cancel-btn" onClick={onCancel} disabled={saving}>
//                 Cancel
//               </button>
//             )}
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddCertificateForm;



















// ////sagar
// import React, { useState } from 'react';
// import './AddCertificateForm.css';

// const generateCertNo = () => {
//   const num = Math.floor(Math.random() * 100).toString().padStart(2, '0');
//   const randomPart = Math.random().toString(36).substring(2, 8).toUpperCase();
//   return `DTECH${num}${randomPart}`;
// };

// const getEmptyForm = () => ({
//   // --- Certificate fields (unchanged) ---
//   studentName: '',
//   branch: '',
//   course: '',
//   centre: 'Dhanbad',
//   startDate: '',
//   endDate: '',
//   awardedOn: '',
//   certNo: generateCertNo(),
//   // --- New record-only fields (NOT used on the certificate) ---
//   fatherName: '',
//   email: '',
//   dob: '',
//   address: '',
//   qualification: '',
//   college: '',
//   mobile: '',
// });

// const AddCertificateForm = ({ onSaved, initialData = null, onCancel }) => {
//   const isEditMode = Boolean(initialData);

//   const [form, setForm] = useState(() =>
//     isEditMode
//       ? {
//           studentName: initialData.studentName || '',
//           branch: initialData.branch || '',
//           course: initialData.course || '',
//           centre: initialData.centre || 'Dhanbad',
//           startDate: initialData.startDate || '',
//           endDate: initialData.endDate || '',
//           awardedOn: initialData.awardedOn || '',
//           certNo: initialData.certNo || generateCertNo(),
//           fatherName: initialData.fatherName || '',
//           email: initialData.email || '',
//           dob: initialData.dob || '',
//           address: initialData.address || '',
//           qualification: initialData.qualification || '',
//           college: initialData.college || '',
//           mobile: initialData.mobile || '',
//         }
//       : getEmptyForm()
//   );
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (!form.studentName || !form.branch || !form.course || !form.startDate || !form.endDate) {
//       setError('Please fill in all required fields.');
//       return;
//     }

//     setSaving(true);
//     try {
//       const url = isEditMode ? `/api/certificates/${initialData.certId}` : '/api/certificates';
//       const method = isEditMode ? 'PUT' : 'POST';

//       const res = await fetch(url, {
//         method,
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(form),
//       });

//       if (!res.ok) throw new Error(isEditMode ? 'Failed to update student details' : 'Failed to save student details');

//       const saved = await res.json();
//       onSaved(saved);
//       if (!isEditMode) setForm(getEmptyForm());
//     } catch (err) {
//       setError(err.message || 'Something went wrong while saving.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="acf-card">
//       <div className="acf-body">
//         <h4 className="acf-heading">{isEditMode ? 'Edit Student Details' : 'Add Student Details'}</h4>

//         {error && <div className="acf-alert-error">{error}</div>}

//         <form className="acf-form" onSubmit={handleSubmit}>
//           <div className="acf-row">
//             {/* ===== Certificate fields (unchanged — these drive the certificate) ===== */}
//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Student Name *</label>
//               <input type="text" className="acf-input" name="studentName" value={form.studentName} onChange={handleChange} placeholder="e.g. Subash Kumar" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Branch *</label>
//               <input type="text" className="acf-input" name="branch" value={form.branch} onChange={handleChange} placeholder="e.g. Civil Engineering" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Course / Training *</label>
//               <input type="text" className="acf-input" name="course" value={form.course} onChange={handleChange} placeholder="e.g. AutoCAD & Sketchup Pro" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Training Centre</label>
//               <input type="text" className="acf-input" name="centre" value={form.centre} onChange={handleChange} placeholder="e.g. Dhanbad" />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Start Date *</label>
//               <input type="date" className="acf-input" name="startDate" value={form.startDate} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">End Date *</label>
//               <input type="date" className="acf-input" name="endDate" value={form.endDate} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Awarded On</label>
//               <input type="date" className="acf-input" name="awardedOn" value={form.awardedOn} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Certificate No.</label>
//               <input type="text" className="acf-input acf-input-disabled" name="certNo" value={form.certNo} readOnly disabled />
//             </div>
//           </div>

//           {/* ===== New record-only fields — stored for the student record, NOT shown on the certificate ===== */}
//           <hr style={{ margin: '20px 0' }} />
//           <h5 className="acf-heading" style={{ fontSize: '15px', marginBottom: '12px' }}>Additional Student Details</h5>

//           <div className="acf-row">
//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Father's Name</label>
//               <input type="text" className="acf-input" name="fatherName" value={form.fatherName} onChange={handleChange} placeholder="e.g. Ramesh Kumar" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Email ID</label>
//               <input type="email" className="acf-input" name="email" value={form.email} onChange={handleChange} placeholder="e.g. student@example.com" />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Date of Birth</label>
//               <input type="date" className="acf-input" name="dob" value={form.dob} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Mobile No.</label>
//               <input type="tel" className="acf-input" name="mobile" value={form.mobile} onChange={handleChange} placeholder="e.g. 9876543210" />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Qualification</label>
//               <input type="text" className="acf-input" name="qualification" value={form.qualification} onChange={handleChange} placeholder="e.g. B.Tech" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">College</label>
//               <input type="text" className="acf-input" name="college" value={form.college} onChange={handleChange} placeholder="e.g. BIT Sindri" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Contact Address</label>
//               <input type="text" className="acf-input" name="address" value={form.address} onChange={handleChange} placeholder="e.g. Full residential address" />
//             </div>
//           </div>

//           <div className="acf-btn-row" style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
//             <button type="submit" className="acf-submit-btn" disabled={saving}>
//               {saving ? 'Saving...' : isEditMode ? 'Update Student Details' : 'Save Student Details'}
//             </button>
//             {isEditMode && onCancel && (
//               <button type="button" className="acf-cancel-btn" onClick={onCancel} disabled={saving}>
//                 Cancel
//               </button>
//             )}
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddCertificateForm;











//
////sagar
// import React, { useState, useEffect } from 'react';
// import './AddCertificateForm.css';

// const getNextCertNo = async () => {
//   try {
//     const res = await fetch('/api/certificates'); // reuse your existing GET list endpoint
//     const data = await res.json();

//     // adjust this line if your API wraps the array differently, e.g. data.certificates
//     const certificates = Array.isArray(data) ? data : data.certificates || [];

//     let maxNumber = 39; // manual starting point, fallback if list is empty

//     certificates.forEach((cert) => {
//       const match = cert.certNo?.match(/DT\/CC\/(\d+)/);
//       if (match) {
//         const num = parseInt(match[1], 10);
//         if (num > maxNumber) maxNumber = num;
//       }
//     });

//     return `DT/CC/${maxNumber + 1}`;
//   } catch (err) {
//     console.error('Failed to compute next cert number', err);
//     return `DT/CC/${Date.now()}`; // fallback so form still works
//   }
// };

// const getEmptyForm = () => ({
//   // --- Certificate fields (unchanged) ---
//   studentName: '',
//   branch: '',
//   course: '',
//   centre: 'Dhanbad',
//   startDate: '',
//   endDate: '',
//   awardedOn: '',
//   certNo: '', // filled in by useEffect once component mounts
//   // --- New record-only fields (NOT used on the certificate) ---
//   fatherName: '',
//   email: '',
//   dob: '',
//   address: '',
//   qualification: '',
//   college: '',
//   mobile: '',
// });

// const AddCertificateForm = ({ onSaved, initialData = null, onCancel }) => {
//   const isEditMode = Boolean(initialData);

//   const [form, setForm] = useState(() =>
//     isEditMode
//       ? {
//           studentName: initialData.studentName || '',
//           branch: initialData.branch || '',
//           course: initialData.course || '',
//           centre: initialData.centre || 'Dhanbad',
//           startDate: initialData.startDate || '',
//           endDate: initialData.endDate || '',
//           awardedOn: initialData.awardedOn || '',
//           certNo: initialData.certNo || '',
//           fatherName: initialData.fatherName || '',
//           email: initialData.email || '',
//           dob: initialData.dob || '',
//           address: initialData.address || '',
//           qualification: initialData.qualification || '',
//           college: initialData.college || '',
//           mobile: initialData.mobile || '',
//         }
//       : getEmptyForm()
//   );
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     if (!isEditMode) {
//       getNextCertNo().then((certNo) => {
//         setForm((prev) => ({ ...prev, certNo }));
//       });
//     }
//   }, [isEditMode]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (!form.studentName || !form.branch || !form.course || !form.startDate || !form.endDate) {
//       setError('Please fill in all required fields.');
//       return;
//     }

//     setSaving(true);
//     try {
//       const url = isEditMode ? `/api/certificates/${initialData.certId}` : '/api/certificates';
//       const method = isEditMode ? 'PUT' : 'POST';

//       const res = await fetch(url, {
//         method,
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(form),
//       });

//       if (!res.ok) throw new Error(isEditMode ? 'Failed to update student details' : 'Failed to save student details');

//       const saved = await res.json();
//       onSaved(saved);
//       if (!isEditMode) setForm(getEmptyForm());
//     } catch (err) {
//       setError(err.message || 'Something went wrong while saving.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="acf-card">
//       <div className="acf-body">
//         <h4 className="acf-heading">{isEditMode ? 'Edit Student Details' : 'Add Student Details'}</h4>

//         {error && <div className="acf-alert-error">{error}</div>}

//         <form className="acf-form" onSubmit={handleSubmit}>
//           <div className="acf-row">
//             {/* ===== Certificate fields (unchanged — these drive the certificate) ===== */}
//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Student Name *</label>
//               <input type="text" className="acf-input" name="studentName" value={form.studentName} onChange={handleChange} placeholder="e.g. Subash Kumar" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Branch *</label>
//               <input type="text" className="acf-input" name="branch" value={form.branch} onChange={handleChange} placeholder="e.g. Civil Engineering" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Course / Training *</label>
//               <input type="text" className="acf-input" name="course" value={form.course} onChange={handleChange} placeholder="e.g. AutoCAD & Sketchup Pro" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Training Centre</label>
//               <input type="text" className="acf-input" name="centre" value={form.centre} onChange={handleChange} placeholder="e.g. Dhanbad" />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Start Date *</label>
//               <input type="date" className="acf-input" name="startDate" value={form.startDate} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">End Date *</label>
//               <input type="date" className="acf-input" name="endDate" value={form.endDate} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Awarded On</label>
//               <input type="date" className="acf-input" name="awardedOn" value={form.awardedOn} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Certificate No.</label>
//               <input type="text" className="acf-input acf-input-disabled" name="certNo" value={form.certNo} readOnly disabled />
//             </div>
//           </div>

//           {/* ===== New record-only fields — stored for the student record, NOT shown on the certificate ===== */}
//           <hr style={{ margin: '20px 0' }} />
//           <h5 className="acf-heading" style={{ fontSize: '15px', marginBottom: '12px' }}>Additional Student Details</h5>

//           <div className="acf-row">
//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Father's Name</label>
//               <input type="text" className="acf-input" name="fatherName" value={form.fatherName} onChange={handleChange} placeholder="e.g. Ramesh Kumar" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Email ID</label>
//               <input type="email" className="acf-input" name="email" value={form.email} onChange={handleChange} placeholder="e.g. student@example.com" />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Date of Birth</label>
//               <input type="date" className="acf-input" name="dob" value={form.dob} onChange={handleChange} />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Mobile No.</label>
//               <input type="tel" className="acf-input" name="mobile" value={form.mobile} onChange={handleChange} placeholder="e.g. 9876543210" />
//             </div>

//             <div className="acf-field acf-field-third">
//               <label className="acf-label">Qualification</label>
//               <input type="text" className="acf-input" name="qualification" value={form.qualification} onChange={handleChange} placeholder="e.g. B.Tech" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">College</label>
//               <input type="text" className="acf-input" name="college" value={form.college} onChange={handleChange} placeholder="e.g. BIT Sindri" />
//             </div>

//             <div className="acf-field acf-field-half">
//               <label className="acf-label">Contact Address</label>
//               <input type="text" className="acf-input" name="address" value={form.address} onChange={handleChange} placeholder="e.g. Full residential address" />
//             </div>
//           </div>

//           <div className="acf-btn-row" style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
//             <button type="submit" className="acf-submit-btn" disabled={saving}>
//               {saving ? 'Saving...' : isEditMode ? 'Update Student Details' : 'Save Student Details'}
//             </button>
//             {isEditMode && onCancel && (
//               <button type="button" className="acf-cancel-btn" onClick={onCancel} disabled={saving}>
//                 Cancel
//               </button>
//             )}
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddCertificateForm;






















//13/7/26
import React, { useState, useEffect } from 'react';
import './AddCertificateForm.css';

const getNextCertNo = async () => {
  try {
    const res = await fetch('/api/certificates'); // reuse your existing GET list endpoint
    const data = await res.json();

    // adjust this line if your API wraps the array differently, e.g. data.certificates
    const certificates = Array.isArray(data) ? data : data.certificates || [];

    let maxNumber = 39; // manual starting point, fallback if list is empty

    certificates.forEach((cert) => {
      const match = cert.certNo?.match(/DT\/CC\/(\d+)/);
      if (match) {
        const num = parseInt(match[1], 10);
        if (num > maxNumber) maxNumber = num;
      }
    });

    return `DT/CC/${maxNumber + 1}`;
  } catch (err) {
    console.error('Failed to compute next cert number', err);
    return `DT/CC/${Date.now()}`; // fallback so form still works
  }
};

const getEmptyForm = () => ({
  // --- Certificate fields (unchanged) ---
  studentName: '',
  branch: '',
  course: '',
  centre: 'Dhanbad',
  startDate: '',
  endDate: '',
  awardedOn: '',
  certNo: '', // filled in by useEffect once component mounts
  // --- New record-only fields (NOT used on the certificate) ---
  fatherName: '',
  email: '',
  dob: '',
  address: '',
  qualification: '',
  college: '',
  mobile: '',
});

const AddCertificateForm = ({ onSaved, initialData = null, onCancel }) => {
  const isEditMode = Boolean(initialData);

  const [form, setForm] = useState(() =>
    isEditMode
      ? {
          studentName: initialData.studentName || '',
          branch: initialData.branch || '',
          course: initialData.course || '',
          centre: initialData.centre || 'Dhanbad',
          startDate: initialData.startDate || '',
          endDate: initialData.endDate || '',
          awardedOn: initialData.awardedOn || '',
          certNo: initialData.certNo || '',
          fatherName: initialData.fatherName || '',
          email: initialData.email || '',
          dob: initialData.dob || '',
          address: initialData.address || '',
          qualification: initialData.qualification || '',
          college: initialData.college || '',
          mobile: initialData.mobile || '',
        }
      : getEmptyForm()
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
const [studentImageFile, setStudentImageFile] = useState(null);
const [imagePreview, setImagePreview] = useState(
  initialData?.studentImage ? `/${initialData.studentImage}` : null
);
  useEffect(() => {
    if (!isEditMode) {
      getNextCertNo().then((certNo) => {
        setForm((prev) => ({ ...prev, certNo }));
      });
    }
  }, [isEditMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.studentName || !form.branch || !form.course || !form.startDate || !form.endDate) {
      setError('Please fill in all required fields.');
      return;
    }

    setSaving(true);
    try {
      const url = isEditMode ? `/api/certificates/${initialData.certId}` : '/api/certificates';
      const method = isEditMode ? 'PUT' : 'POST';

      const formData = new FormData();
      Object.entries(form).forEach(([key, value]) => {
        formData.append(key, value ?? '');
      });
      if (studentImageFile) {
        formData.append('studentImage', studentImageFile);
      }

      const res = await fetch(url, {
        method,
        body: formData,
      });

      if (!res.ok) throw new Error(isEditMode ? 'Failed to update student details' : 'Failed to save student details');

      const saved = await res.json();
      onSaved(saved);
      if (!isEditMode) {
        setForm(getEmptyForm());
        setStudentImageFile(null);
        setImagePreview(null);
      }
    } catch (err) {
      setError(err.message || 'Something went wrong while saving.');
    } finally {
      setSaving(false);
    }
  };
  return (
    <div className="acf-card">
      <div className="acf-body">
        <h4 className="acf-heading">{isEditMode ? 'Edit Student Details' : 'Add Student Details'}</h4>

        {error && <div className="acf-alert-error">{error}</div>}

        <form className="acf-form" onSubmit={handleSubmit}>
          <div className="acf-row">
            {/* ===== Certificate fields (unchanged — these drive the certificate) ===== */}
            <div className="acf-field acf-field-half">
              <label className="acf-label">Student Name *</label>
              <input type="text" className="acf-input" name="studentName" value={form.studentName} onChange={handleChange} placeholder="e.g. Subash Kumar" />
            </div>

            <div className="acf-field acf-field-half">
              <label className="acf-label">Branch *</label>
              <input type="text" className="acf-input" name="branch" value={form.branch} onChange={handleChange} placeholder="e.g. Civil Engineering" />
            </div>

            <div className="acf-field acf-field-half">
              <label className="acf-label">Course / Training *</label>
              <input type="text" className="acf-input" name="course" value={form.course} onChange={handleChange} placeholder="e.g. AutoCAD & Sketchup Pro" />
            </div>

            <div className="acf-field acf-field-half">
              <label className="acf-label">Training Centre</label>
              <input type="text" className="acf-input" name="centre" value={form.centre} onChange={handleChange} placeholder="e.g. Dhanbad" />
            </div>

            <div className="acf-field acf-field-third">
              <label className="acf-label">Start Date *</label>
              <input type="date" className="acf-input" name="startDate" value={form.startDate} onChange={handleChange} />
            </div>

            <div className="acf-field acf-field-third">
              <label className="acf-label">End Date *</label>
              <input type="date" className="acf-input" name="endDate" value={form.endDate} onChange={handleChange} />
            </div>

            <div className="acf-field acf-field-third">
              <label className="acf-label">Awarded On</label>
              <input type="date" className="acf-input" name="awardedOn" value={form.awardedOn} onChange={handleChange} />
            </div>

            <div className="acf-field acf-field-third">
              <label className="acf-label">Certificate No.</label>
              <input type="text" className="acf-input acf-input-disabled" name="certNo" value={form.certNo} readOnly disabled />
            </div>
          </div>

          {/* ===== New record-only fields — stored for the student record, NOT shown on the certificate ===== */}
          <hr style={{ margin: '20px 0' }} />
          <h5 className="acf-heading" style={{ fontSize: '15px', marginBottom: '12px' }}>Additional Student Details</h5>

          <div className="acf-row">
            <div className="acf-field acf-field-half">
              <label className="acf-label">Father's Name</label>
              <input type="text" className="acf-input" name="fatherName" value={form.fatherName} onChange={handleChange} placeholder="e.g. Ramesh Kumar" />
            </div>

            <div className="acf-field acf-field-half">
              <label className="acf-label">Email ID</label>
              <input type="email" className="acf-input" name="email" value={form.email} onChange={handleChange} placeholder="e.g. student@example.com" />
            </div>

            <div className="acf-field acf-field-third">
              <label className="acf-label">Date of Birth</label>
              <input type="date" className="acf-input" name="dob" value={form.dob} onChange={handleChange} />
            </div>

            <div className="acf-field acf-field-third">
              <label className="acf-label">Mobile No.</label>
              <input type="tel" className="acf-input" name="mobile" value={form.mobile} onChange={handleChange} placeholder="e.g. 9876543210" />
            </div>

            <div className="acf-field acf-field-third">
              <label className="acf-label">Qualification</label>
              <input type="text" className="acf-input" name="qualification" value={form.qualification} onChange={handleChange} placeholder="e.g. B.Tech" />
            </div>

            <div className="acf-field acf-field-half">
              <label className="acf-label">College</label>
              <input type="text" className="acf-input" name="college" value={form.college} onChange={handleChange} placeholder="e.g. BIT Sindri" />
            </div>

            <div className="acf-field acf-field-half">
              <label className="acf-label">Contact Address</label>
              <input type="text" className="acf-input" name="address" value={form.address} onChange={handleChange} placeholder="e.g. Full residential address" />
            </div>
          </div>
<div className="acf-field acf-field-half">
    <label className="acf-label">Student Photo</label>
    <input type="file" accept="image/*" onChange={(e) => {
      const file = e.target.files[0];
      setStudentImageFile(file);
      if (file) setImagePreview(URL.createObjectURL(file));
    }} />
    {imagePreview && <img src={imagePreview} alt="preview" style={{ width: 80, height: 80, objectFit: 'cover', marginTop: 8, borderRadius: 6 }} />}
  </div>
          <div className="acf-btn-row" style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
            <button type="submit" className="acf-submit-btn" disabled={saving}>
              {saving ? 'Saving...' : isEditMode ? 'Update Student Details' : 'Save Student Details'}
            </button>
            {isEditMode && onCancel && (
              <button type="button" className="acf-cancel-btn" onClick={onCancel} disabled={saving}>
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCertificateForm;